import React, { useEffect } from "react";
import "./App.css";
import { Toaster } from "sonner";
import { ThemeProvider, useTheme } from "./context/ThemeContext";

// Components
import NexmoveHeader from "./components/NexmoveHeader";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import ValueSection from "./components/ValueSection";
import ProcessSection from "./components/ProcessSection";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";
import NexmoveFooter from "./components/NexmoveFooter";

const AppContent = () => {
  const { isDark } = useTheme();
  
  // Update document title dynamically for better SEO
  useEffect(() => {
    document.title = "NEXMOVE Consulting Limited | Renewable Energy & Agro-Culture Solutions in Nigeria";
  }, []);
  
  return (
    <div className="App" role="application" aria-label="NEXMOVE Consulting Website">
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: isDark ? '#1A2420' : '#ffffff',
            border: isDark ? '1px solid rgba(0, 135, 61, 0.2)' : '1px solid rgba(0, 102, 51, 0.1)',
            color: isDark ? '#ffffff' : '#1A1A1A',
            fontFamily: "'Inter', Arial, sans-serif",
            borderRadius: '12px',
            boxShadow: isDark 
              ? '0 10px 40px rgba(0, 0, 0, 0.3)' 
              : '0 10px 40px rgba(0, 0, 0, 0.1)'
          }
        }}
      />
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-nexmove-green focus:text-white focus:px-4 focus:py-2 focus:rounded">
        Skip to main content
      </a>
      <NexmoveHeader />
      <main id="main-content" role="main" aria-label="Main content">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ValueSection />
        <ProcessSection />
        <CTASection />
        <ContactSection />
      </main>
      <NexmoveFooter />
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
